import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'

import {
  CheckboxCustom,
  CheckboxCustomFilled,
  CheckboxError,
  CheckboxInput,
  Container,
  IconBox,
  Wrapper,
} from './styles'

const CheckboxInner = ({
  meta,
  input,
  label,
  isDisabled,
  isCheckInEnd,
  isFilled,
  size,
  ...checkboxProps
}) => {
  const isError = React.useMemo(
    () => (meta.touched || meta.submitFailed) && meta.error !== undefined,
    [meta],
  )

  let LabelComponent = React.useMemo(() => {
    if (!label) return null

    if (typeof label === 'string') {
      return <span dangerouslySetInnerHTML={{ __html: label }} />
    } else {
      return <span>{label}</span>
    }
  }, [label])

  const CustomCheckbox = React.useMemo(
    () =>
      isFilled ? (
        <CheckboxCustomFilled
          size={size}
          {...{ isCheckInEnd, isError, isDisabled }}
        >
          <IconBox>
            <Icon id="btn_check_xs" color="white" strokeWidth="1.2" />
          </IconBox>
        </CheckboxCustomFilled>
      ) : (
        <CheckboxCustom {...{ isCheckInEnd, isError, isDisabled }} />
      ),
    [isFilled, size, isCheckInEnd, isError, isDisabled],
  )

  return (
    <Wrapper>
      <label>
        <CheckboxInput
          {...checkboxProps}
          type="checkbox"
          disabled={isDisabled}
          {...input}
        />
        {isCheckInEnd ? (
          <>
            {LabelComponent}
            {isCheckInEnd && CustomCheckbox}
          </>
        ) : (
          <Container>
            {CustomCheckbox}
            {LabelComponent}
          </Container>
        )}
        {isError && (
          <CheckboxError
            size={size}
            shifted={!isCheckInEnd}
            dangerouslySetInnerHTML={{ __html: meta.error }}
          />
        )}
      </label>
    </Wrapper>
  )
}

CheckboxInner.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  isCheckInEnd: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isFilled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'base']),
}
CheckboxInner.defaultProps = {
  isDisabled: false,
  isCheckInEnd: false,
  isFilled: false,
  size: 'small',
}

export default CheckboxInner
